// AUTO-GENERATED by scripts/build-product-facts.ts — do not edit by hand.
// Canonical, verified-only product facts extracted from the merchant's own
// Shopify product content. Fields that could not be verified are absent and
// must never be rendered as confirmed information.
// Regenerate:  bun scripts/build-product-facts.ts

import type { ProductFacts } from "@/lib/product-facts";

export const PRODUCT_FACTS: Record<string, ProductFacts> = {
  "2-in-1-montessori-climbing-triangle-with-ramp": {
    "recommendedAge": "10 kk – 6 v",
    "ageMinMonths": 10,
    "ageMaxMonths": 72,
    "material": "Koivuvaneri, myrkytön viimeistely",
    "includes": "Säädettävä kiipeilykolmio + käännettävä ramppi",
    "standards": [
      "EN 71"
    ]
  },
  "transformable-montessori-climber-with-ramp": {
    "weight": "90 kg",
    "material": "Baltialainen koivuvaneri",
    "featureList": [
      "Kehittää motorisia taitoja ja fyysistä koordinaatiota",
      "Kannustaa avoimeen, itsenäiseen leikkiin",
      "Parantaa tasapainoa, tilatietoisuutta ja kehonhallintaa",
      "Rakentaa itseluottamusta fyysisten haasteiden kautta",
      "Tukee uteliaisuutta ja mielikuvituksellista tutkimista",
      "Valmistettu Euroopan unionissa",
      "Sertifioitu EN 71-1, 71-2, 71-3, 71-8, 71-9 -turvallisuusstandardien mukaisesti",
      "Aikuisten valvonta aina suositeltavaa"
    ],
    "maxLoad": "90 kg",
    "standards": [
      "EN 71"
    ]
  },
  "montessori-3-angle-climber": {
    "recommendedAge": "12 kk – 6 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 72,
    "material": "Kestävä koivuvaneri, myrkyttömät lakat",
    "featureList": [
      "Kolmiseinäinen, vakaa jalusta"
    ]
  },
  "montessori-3-angle-climber-with-ramp": {
    "recommendedAge": "12 kk – 6 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 72,
    "material": "Koivuvaneri, myrkytön viimeistely",
    "includes": "Kolmiseinäinen kiipeilyteline + käännettävä ramppi",
    "standards": [
      "EN 71"
    ]
  },
  "montessori-climbing-arch": {
    "recommendedAge": "6 kk – 6 v",
    "ageMinMonths": 6,
    "ageMaxMonths": 72,
    "material": "Koivuvaneri, myrkytön pintakäsittely"
  },
  "transformable-montessori-climber": {
    "material": "Baltialainen koivuvaneri",
    "featureList": [
      "Kehittää karkeamotoriikkaa ja fyysistä koordinaatiota",
      "Kannustaa avoimeen, itsenäiseen leikkiin",
      "Parantaa tasapainoa, tilatietoisuutta ja kehonhallintaa",
      "Rakentaa itseluottamusta fyysisten haasteiden kautta",
      "Tukee uteliaisuutta ja mielikuvituksellista tutkimusta",
      "Valmistettu Euroopan unionissa",
      "Sertifioitu EN 71-1, 71-2, 71-3, 71-8, 71-9 -turvallisuusstandardien mukaisesti",
      "Aikuisten valvonta aina suositeltavaa"
    ],
    "standards": [
      "EN 71"
    ]
  },
  "montessori-climbing-arch-with-ramp": {
    "recommendedAge": "6 kk – 6 v",
    "ageMinMonths": 6,
    "ageMaxMonths": 72,
    "material": "Koivuvaneri, myrkyttömät vesiohenteiset lakat",
    "includes": "Kiipeilykaari + käännettävä ramppi",
    "standards": [
      "EN 71"
    ]
  },
  "montessori-play-stand-toy-shelf-for-kids": {
    "recommendedAge": "12 kk – 6 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 72,
    "dimensions": "Selkeät ohjeet mukana – suosittelemme kokoamaan lapsen kanssa yhdessä.",
    "material": "Koivuvaneri, myrkyttömät vesiohenteiset lakat",
    "includes": "Leikkitelineen ilman lisävarusteita"
  },
  "montessori-climbing-triangle": {
    "recommendedAge": "10 kk – 5 v",
    "ageMinMonths": 10,
    "ageMaxMonths": 60,
    "material": "Kestävä koivuvaneri, myrkytön vesiohenteinen viimeistely",
    "standards": [
      "EN 71"
    ]
  },
  "montessori-climbing-triangle-with-ramp": {
    "recommendedAge": "10 kk – 5 v",
    "ageMinMonths": 10,
    "ageMaxMonths": 60,
    "material": "Koivuvaneri, myrkytön viimeistely",
    "includes": "Kiipeilykolmio + käännettävä ramppi (liukumäki / kiipeilyseinä)",
    "standards": [
      "EN 71"
    ]
  },
  "toddlers-clothing-rack-for-hangers-ver-2": {
    "dimensions": "Helpot ohjeet, ei työkaluja\nPituus 96 cm, syvyys 35 cm, korkeus 103,5 cm (alahyllyltä ripustustankoon 89,5 cm)",
    "material": "1,2 cm koivuvaneri, myrkyttömät pinnat",
    "includes": "Puinen vaateteline ilman erillisiä ripustimia",
    "featureList": [
      "Edistää käytännön elämäntaitoja",
      "Antaa lapselle mahdollisuuden itsenäisesti pukeutua",
      "Auttaa opettamaan järjestelmällisyyttä",
      "Kehittää itseluottamusta ja ongelmanratkaisukykyä",
      "Sopii Montessori- ja Waldorf-pedagogiikkaan"
    ]
  },
  "2in1-kitchen-tower-table-chair": {
    "recommendedAge": "12 kk – 6 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 72,
    "material": "Koivuvaneri, myrkyttömät vesiohenteiset lakat"
  },
  "transformable-kitchen-tower-table-chair": {
    "recommendedAge": "12 kk – 6 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 72,
    "dimensions": "Korkeus 90 cm, leveys 40 cm, syvyys 44 cm",
    "material": "Baltialainen koivuvaneri, myrkyttömät vesiohenteiset lakat",
    "featureList": [
      "Muunneltava muotoilu: vaihtuu helposti keittiöportaasta pöytä- ja tuolisetiksi",
      "Kannustaa kulinaariseen itsevarmuuteen ja aterioiden yhteiseen valmistukseen",
      "Säädettävät korkeudet: kiipeilytaso 22 cm (±5 cm), ylin taso 44 cm (±5 cm)",
      "Käsintehty Latviassa EU:n paikallisista materiaaleista",
      "Sopii 1–6-vuotiaille lapsille"
    ]
  },
  "montessori-weaning-table-and-chair-set-with-2-chairs": {
    "recommendedAge": "12 kk – 5 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 60,
    "dimensions": "Nopea ja helppo, selkeät ohjeet mukana",
    "material": "Baltialainen koivuvaneri, myrkyttömät lapsiturvalliset pinnat (käsintehty Latviassa)",
    "includes": "Yksi pöytä ja kaksi tuolia"
  },
  "montessori-helper-tower-step-stool-kitchen-tower-with-blackboard": {
    "recommendedAge": "12 kk – 5 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 60,
    "material": "Koivuvaneri, myrkyttömät lakat",
    "featureList": [
      "Liitutaulu etuseinässä",
      "Säädettävä askelma",
      "Suojaavat kaiteet kaikilla sivuilla"
    ]
  },
  "house-shaped-shelf-for-kids": {
    "dimensions": "Työkalut ja ohjeet mukana, aika noin 25–50 min\nLeveys 68 cm, korkeus 140 cm, syvyys 33 cm",
    "material": "Massiivipuu — mänty tai koivu valintasi mukaan",
    "featureList": [
      "Mäntypuu: kestävä massiivimänty, käsitelty luonnollisella mehiläisvahalla",
      "Koivu: vaaleampi ja sileämpi pinta, hienosyisempää puuta",
      "Hyllyväli: 35 cm",
      "Puuprofiili: 3 × 4 cm"
    ]
  },
  "house-shaped-clothing-rack-with-storage": {
    "recommendedAge": "18 kk – esikouluikä",
    "ageMinMonths": 18,
    "material": "Massiivimänty tai koivuvaneri",
    "featureList": [
      "Talomuotoinen runko, naulakko ja alahyllyt säilytykseen",
      "Kestää raskaatkin talvitakit"
    ]
  },
  "montessori-helper-tower-step-stool": {
    "recommendedAge": "12 kk – 5 v",
    "ageMinMonths": 12,
    "ageMaxMonths": 60,
    "material": "Koivuvaneri, myrkyttömät vesiohenteiset lakat",
    "featureList": [
      "Säädettävä askelmakorkeus",
      "Vakaa leveä jalusta",
      "Suojaavat kaiteet joka sivulla"
    ]
  },
  "2-in-1-montessori-climbing-triangle": {
    "recommendedAge": "10 kk – 6 v",
    "ageMinMonths": 10,
    "ageMaxMonths": 72,
    "material": "Koivuvaneri, myrkytön viimeistely",
    "featureList": [
      "Säädettävä korkeus",
      "Kokoontaitettava säilytystä varten"
    ]
  },
  "clothing-rack-with-shelves-for-toddlers": {
    "recommendedAge": "18 kk – esikouluikä",
    "ageMinMonths": 18,
    "material": "Koivuvaneri, myrkytön viimeistely",
    "featureList": [
      "Naulakko ja kaksi alahyllyä",
      "Sopii kenkien ja korien säilytykseen"
    ]
  },
  "wooden-kids-floor-table-montessori-toddler-activity-table": {
    "recommendedAge": "Taaperoille",
    "ageMinMonths": 12,
    "ageMaxMonths": 48,
    "dimensions": "Pituus 50 cm, leveys 38 cm, pöytätason korkeus 21 cm, kokonaiskorkeus 28 cm",
    "material": "Luonnonpuu",
    "care": "Pyyhi puhtaaksi kostealla liinalla. Vältä voimakkaita kemikaaleja.",
    "ecology": "Valmistettu korkealaatuisesta luonnonpuusta, turvallinen lapselle ja ympäristölle.",
    "featureList": [
      "Montessori-henkinen muotoilu kannustaa itsenäisyyteen",
      "Sileät, pyöristetyt reunat lapselle turvalliseksi",
      "Kevyt siirtää huoneesta toiseen tai ulos",
      "Minimalistinen ilme sopii mihin tahansa sisustukseen",
      "Käsintehty Latviassa"
    ],
    "manufacturer": "OakHill"
  },
  "montessori-wooden-clothes-drying-rack-with-storage-for-kids": {
    "recommendedAge": "Taaperot ja esikoululaiset",
    "ageMinMonths": 12,
    "ageMaxMonths": 48,
    "dimensions": "Korkeus 100 cm, leveys 63 cm, syvyys 35 cm",
    "material": "Tukeva koivuvanerirunko, sileät ja turvalliset pinnat",
    "includes": "Kangaspyykkikori (harmaa, beige tai vihreä)",
    "featureList": [
      "Korin mitat: 53 × 32,8 × 32,8 cm",
      "Käsintehty Latviassa"
    ],
    "manufacturer": "OakHill"
  },
  "montessori-wooden-shelf-kids-storage-organizer": {
    "dimensions": "Korkeus 100 cm, leveys 60 cm, syvyys 35 cm (hyllyvälit 24 cm ja 24 cm, pohjalokero 44 cm)",
    "material": "FSC-sertifioitu koivuvaneri",
    "ecology": "FSC-sertifioitu koivuvaneri, huolellisesti hiottu ja käsittelemätön — turvallinen lasten ympäristöön. Käsintehty Euroopassa.",
    "featureList": [
      "Kolme tasoa: kaksi avointa hyllyä ja syvä pohjalokero säilytyskoreille",
      "Lapsen korkuinen — sopii taaperoille ja pienille lapsille",
      "Sileät reunat ja tukeva rakenne",
      "Neutraali, moderni ilme leikkihuoneeseen tai olohuoneeseen",
      "Litteä pakkaus, kokoaminen muutamassa minuutissa"
    ],
    "manufacturingRegion": "Eurooppa",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "OakHill"
  },
  "montessori-double-sided-wooden-book-display-for-kids": {
    "dimensions": "Leveys 53 cm, korkeus 25 cm, syvyys 29 cm",
    "material": "Korkealaatuinen koivuvaneri",
    "featureList": [
      "4 kaksipuolista tasoa — kirjat esillä molemmilta puolilta",
      "Pyöristetyt sivukahvat helppoon siirtelyyn",
      "Tukeva runko",
      "Käsintehty Latviassa"
    ],
    "manufacturer": "OakHill"
  },
  "wooden-toy-box-montessori-nursery-storage": {
    "dimensions": "Pieni 45 × 35 × 22 cm, iso 58 × 40 × 22 cm",
    "material": "Kestävä, korkealaatuinen puu, luonnollinen viimeistely",
    "featureList": [
      "Kestävä, korkealaatuinen puu ja moderni muotoilu",
      "Leikkisä \"TOYS\"-leikkaus etusivussa",
      "Tilava säilytyskapasiteetti",
      "Sileät kahvat molemmilla puolilla nostamista varten",
      "Pyöristetyt reunat pienten käsien turvaksi",
      "Käsintehty Latviassa"
    ],
    "manufacturer": "OakHill"
  },
  "montessori-wooden-front-facing-book-display-for-kids": {
    "dimensions": "Leveys 61,5 cm, korkeus 47,5 cm, syvyys 30 cm",
    "material": "Korkealaatuinen koivuvaneri",
    "featureList": [
      "4 eteenpäin suunnattua tasoa",
      "Hyllyvälit: alahylly 7,5 cm, keskihyllyt 15 cm, kahvan korkeus 21 cm",
      "Pyöristetyt sivukahvat helppoon siirtelyyn",
      "Tukeva ja lapsiystävällinen rakenne",
      "Käsintehty Latviassa"
    ],
    "manufacturer": "OakHill"
  },
  "safety-and-comfort-5-mat-set-pastel": {
    "includes": "5 pehmomattoa",
    "ecology": "100 % kierrätettävä, tiheä mutta kevyt vaahtomuovi suljetulla solurakenteella; päällys kestävää keinonahkaa. Testattu haitallisten aineiden varalta.",
    "featureList": [
      "Rohkaisee fyysiseen aktiivisuuteen ja motoristen taitojen kehittymiseen",
      "Tarjoaa aististimulaatiota ja mielikuvituksen ruokkimista",
      "Edistää sosiaalisia taitoja: jakamista ja yhteistyötä",
      "Kevyt, helppo siirtää ja pinota",
      "Pyyhitään puhtaaksi kostealla liinalla",
      "Käsintehty ompelusta pakkaukseen"
    ],
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "montessori-soft-play-set-light-pastel": {
    "ecology": "Valmistettu Euroopassa korkealaatuisista, kierrätettävistä materiaaleista. Ekologinen keinonahkapäällyste. Tuotanto sertifioitu ISO 9001-, ISO 14001-, ISO 45001- ja ISO 50001 -standardien mukaisesti.",
    "featureList": [
      "Kannustaa itsenäiseen ajatteluun ja ongelmanratkaisuun",
      "Tukee motorisia taitoja, tasapainoa ja koordinaatiota",
      "Aisteja miellyttävä muotoilu kirkkailla sateenkaaren väreillä",
      "Pehmeät vaahtomuovipalat pyöristetyillä reunoilla",
      "Kevyt ja helppo lapsen siirtää ja pinota",
      "Helppo pyyhkiä puhtaaksi"
    ],
    "manufacturingRegion": "Eurooppa",
    "standards": [
      "EN 71",
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-set-tunnel-pastel": {
    "ecology": "100 % kierrätettävä, tiheä mutta kevyt vaahtomuovi suljetulla solurakenteella; päällys kestävää keinonahkaa. Testattu haitallisten aineiden varalta.",
    "featureList": [
      "Kannustaa fyysiseen aktiivisuuteen ja motoristen taitojen kehittymiseen",
      "Tukee mielikuvitusta ja sosiaalisia taitoja",
      "Tarjoaa aististimulaatiota",
      "Kevyt ja helppo siirtää",
      "Helppo puhdistaa kostealla liinalla",
      "Käsintehty ompelusta pakkaukseen"
    ],
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-step-and-slide-set": {
    "ecology": "100 % kierrätettävä, tiheä mutta kevyt vaahtomuovi suljetulla solurakenteella; päällys kestävää keinonahkaa. Testattu haitallisten aineiden varalta.",
    "featureList": [
      "Kannustaa fyysiseen aktiivisuuteen ja karkeamotoriikkaan",
      "Kehittää tasapainoa ja koordinaatiota",
      "Tukee mielikuvitusta ja sosiaalisia taitoja",
      "Kevyt ja turvallinen lapsen käyttöön",
      "Helppo puhdistaa kostealla liinalla",
      "Käsintehty Euroopassa"
    ],
    "manufacturingRegion": "Eurooppa",
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-shape-wedge": {
    "recommendedAge": "6 – 36 kk",
    "ageMinMonths": 6,
    "ageMaxMonths": 36,
    "dimensions": "40 × 40 × 20 cm",
    "featureList": [
      "Kannustaa liikkumaan ja kehittää motorisia taitoja",
      "Tukee mielikuvitusta ja avointa leikkiä",
      "Purkaa ylimääräistä energiaa ja auttaa rentoutumaan",
      "Tarjoaa aistivirikkeitä",
      "Vie huomion pois ruuduista",
      "Edistää sosiaalisia taitoja",
      "Testattu haitallisten aineiden varalta",
      "CE-merkitty EU:n leluturvallisuusdirektiivin 2009/48/EY mukaisesti",
      "Valmistettu Latviassa"
    ],
    "manufacturingCountry": "Latvia",
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "foam-mega-cube-building-block": {
    "featureList": [
      "Kannustaa luovuuteen ja tilalliseen hahmottamiseen",
      "Kevyt ja helppo siirtää leikistä toiseen pienilläkin käsillä",
      "Pehmeä vaahtomuovimateriaali pitää leikin turvallisena ja pehmeänä lattialla",
      "Kestävä, pyyhittävä pinta takaa helpon puhdistuksen ja pitkäikäisyyden",
      "CE-merkitty lelun turvallisuuden osalta",
      "Täyttää EN71-standardit mekaanisen turvallisuuden, syttyvyyden ja kemiallisen siirtymän osalta",
      "Valmistettu sertifioitujen laatu- ja turvallisuusprosessien mukaisesti"
    ],
    "standards": [
      "EN 71",
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-ride-on-toy-car": {
    "ecology": "100 % kierrätettävä, tiheä mutta kevyt vaahtomuovi suljetulla solurakenteella; päällys kestävää keinonahkaa, testattu haitallisten aineiden varalta.",
    "featureList": [
      "Kannustaa fyysiseen aktiivisuuteen",
      "Lisää luovuutta ja mielikuvitusta",
      "Auttaa purkamaan ylimääräistä energiaa ja rentoutumaan",
      "Tarjoaa aististimulaatiota",
      "Pitää lapset poissa näyttöjen äärestä",
      "Edistää sosiaalisia taitoja, kuten jakamista ja yhteistyötä",
      "Erittäin kestävä – pitää muotonsa mutta on kevyt käsitellä",
      "Helppo puhdistaa – pyyhitään puhtaaksi kostealla liinalla",
      "Käsintehty huolellisesti ompelusta pakkaukseen",
      "Valmistettu Pohjois-Euroopassa"
    ],
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-mega-wave": {
    "ecology": "100 % kierrätettävä vaahtomuovi suljetulla solurakenteella; päällys kestävää keinonahkaa.",
    "featureList": [
      "Kehittää karkeamotorisia taitoja, tasapainoa ja koordinaatiota",
      "Pehmeä vaahtomuovi tuntuu turvalliselta liikkeessä",
      "Kevyt rakenne on helppo siirtää ja muuntaa uusiin leikkeihin",
      "Kestävä ja pyyhittävä pinta päivittäiseen käyttöön",
      "CE-merkitty ja EN71-standardin mukainen",
      "Valmistettu sertifioitujen laatuprosessien mukaisesti"
    ],
    "standards": [
      "EN 71",
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-ball-pit": {
    "recommendedAge": "1 v +",
    "ageMinMonths": 12,
    "dimensions": "130 × 130 cm",
    "weight": "7,9 kg",
    "material": "100 % kierrätettävä vaahtomuovi suljetulla solurakenteella; pinta kestävää keinonahkaa, testattu haitallisten aineiden varalta.",
    "featureList": [
      "Korkeus lattiasta 25 cm",
      "Matalaprofiilinen sisäänkäynti taaperolle",
      "CE-merkitty EU:n leluturvallisuusdirektiivin 2009/48/EY mukaisesti",
      "Valmistettu Latviassa"
    ],
    "manufacturingCountry": "Latvia",
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-ball-pit-balls-500pc": {
    "dimensions": "Halkaisija 7 cm",
    "includes": "500 kpl – täydellinen määrä yhdelle pallomerelle",
    "featureList": [
      "Turvallinen ja hellävarainen – myrkyttömistä materiaaleista, hypoallergeeniset ja hajuttomat",
      "Halkaisija 7 cm – ihanteellinen pienten käsien tarttua ja heittää",
      "Kestävät hankausta ja iskuja, palautuvat nopeasti muotoonsa"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-activity-set-balance-bridge": {
    "ecology": "100 % kierrätettävä vaahtomuovi suljetulla solurakenteella; päällys kestävää keinonahkaa, testattu haitallisten aineiden varalta.",
    "featureList": [
      "Kannustaa fyysiseen aktiivisuuteen ja motoristen taitojen kehittymiseen",
      "Tukee mielikuvitusta ja sosiaalisia taitoja",
      "Tarjoaa aististimulaatiota",
      "Kevyt ja turvallinen lapsen käyttöön",
      "Helppo puhdistaa kostealla liinalla",
      "Käsintehty Pohjois-Euroopassa"
    ],
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-7-foam-block-set-discoverer": {
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-8-foam-block-set-adventurer": {
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-7-foam-block-set-little-crawler": {
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-6-foam-block-set-explorer": {
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "soft-play-5-foam-block-set-corner-climber": {
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "rocking-chair": {
    "dimensions": "60 x 60 cm",
    "manufacturingCountry": "Latvia",
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "rainbow-bridge-soft-play-set": {
    "standards": [
      "CE-merkintä"
    ],
    "manufacturer": "IGLU"
  },
  "wall-mounted-drawing-board": {
    "recommendedAge": "2 v +",
    "ageMinMonths": 24,
    "dimensions": "Pituus: 70 cm\nLeveys: 53 cm\nSopii universaaleille paperirullille",
    "material": "Laadukas luonnonpuu ja lapselle turvalliset viimeistelyt",
    "assembly": "Seinäkiinnitys, tukeva ja helppo asentaa",
    "care": "Pyyhi kuivalla tai kevyesti kostealla liinalla",
    "featureList": [
      "Paperiyhteensopivuus: Suunniteltu leg&go-paperirullalle, yhteensopiva vakiokokoisten rullien kanssa"
    ],
    "manufacturer": "leg&go"
  },
  "wooden-baby-gym": {
    "dimensions": "Korkeus: 56 cm\nPituus: 70 cm\nLeveys: 59 cm\nRungon paino: 1,6 kg",
    "manufacturingRegion": "Eurooppa",
    "manufacturer": "leg&go"
  },
  "balance-beams-set-of-6": {
    "dimensions": "Yksi puomi: leveys 8 cm, pituus 75 cm, paksuus 1,5 cm, korkeus lattiasta 6 cm\nSetin pituus: 6 puomia, yhteensä 460 cm\nValmistettu Latviassa",
    "weight": "50 kg",
    "maxLoad": "50 kg",
    "manufacturingCountry": "Latvia",
    "manufacturer": "leg&go"
  },
  "leg-go-balance-bike-3in1": {
    "weight": "3,3 kg",
    "manufacturingRegion": "Eurooppa",
    "manufacturer": "leg&go"
  },
  "foldable-kitchen-tower-zigzag": {
    "dimensions": "87 cm (K) × 41 cm (L) × 48 cm (P)",
    "maxLoad": "50 kg",
    "manufacturingRegion": "Eurooppa",
    "manufacturer": "leg&go"
  },
  "wooden-round-pyramid-natural": {
    "recommendedAge": "1 v +",
    "ageMinMonths": 12,
    "dimensions": "Suurin palikka: 12 × 12 × 1,8 cm\nPienin palikka: 4 × 4 × 3,7 cm\nIlman pakkausta: 12 × 12 × 17,9 cm\nPakkauksen kanssa: 13,6 × 14 × 22,4 cm",
    "weight": "0,75 kg",
    "ecology": "Valmistettu FSC-sertifioidusta puusta\nViimeistelty mehiläisvahalla ja kasviöljyillä – poikkeuksellisen sileä ja miellyttävä koskettaa\nKierrätettävä pahvipakkaus\nEi haitallisia aineita",
    "featureList": [
      "Sileät, miellyttävän tuntuiset palikat",
      "Opettaa kokojen tunnistamista",
      "Kehittää silmän ja käden yhteistyötä",
      "Harjoittaa loogista ajattelua"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "large-multifunctional-wooden-food-truck-stand-73-pcs": {
    "recommendedAge": "3 v+, sopii kaikille lapsille",
    "ageMinMonths": 36,
    "dimensions": "76 × 31 × 93 cm; paino: 10,45 kg",
    "featureList": [
      "73 osan setti: puinen myyntikoju, vaaka, korttilukija, liitutaulu ja monipuolinen valikoima leikkiruokia",
      "Kannustaa roolileikkiin, vuorovaikutukseen, laskemiseen ja järjestelyyn",
      "Valmistettu FSC-sertifioidusta puusta myrkyttömillä maaleilla"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Woopie Let's Go Green"
  },
  "small-single-montessori-open-bowl-wash-station": {
    "dimensions": "Toimitetaan litteänä pakattuna\nNopea ja helppo koota — kaikki tarvittavat osat mukana, tarvitset vain ristipääruuvimeisselin\nEmaliallas on kestävä, helppo puhdistaa ja hygieeninen",
    "includes": "Puinen pesuteline\nEmaloitu teräksinen pesuallas (halkaisija 24 cm)",
    "manufacturingCountry": "Latvia",
    "manufacturer": "OakHill"
  },
  "wooden-square-pyramid-natural": {
    "recommendedAge": "1 v +",
    "ageMinMonths": 12,
    "weight": "1 kg",
    "ecology": "Valmistettu FSC-sertifioidusta puusta",
    "featureList": [
      "Sileät, miellyttävän tuntuiset palikat"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "cubitri®-climbing-play-cube-with-rope-window": {
    "recommendedAge": "12 kk +",
    "ageMinMonths": 12,
    "dimensions": "Korkeus: 58,4 cm\nLeveys: 58,4 cm\nSyvyys: 58,4 cm",
    "manufacturingCountry": "Latvia",
    "standards": [
      "OEKO-TEX"
    ],
    "manufacturer": "Ette Tete"
  },
  "wooden-tree-crown-puzzle": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "32,8 × 8,3 × 19,5 cm",
    "ecology": "Valmistettu FSC-sertifioidusta puusta",
    "featureList": [
      "Opettaa puiden latvustojen muotoja ja tyyppejä"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-montessori-number-board": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "ecology": "Valmistettu FSC-sertifioidusta puusta",
    "featureList": [
      "Numeroiden kirjoittamisen harjoittelu"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-toy-acrobat-girl": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "weight": "0,4 kg",
    "ecology": "Valmistettu FSC-sertifioidusta puusta",
    "featureList": [
      "Kehittää käsityötaitoja, tarkkuutta ja keskittymistä"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-walnut-doll-with-pants": {
    "recommendedAge": "2 v +",
    "ageMinMonths": 24,
    "dimensions": "Nukke 19 cm · Pakkauksen kanssa 14 × 22,5 × 5,5 cm",
    "weight": "200 g",
    "material": "FSC-sertifioitujen toimittajien pähkinäpuu, luonnollinen puun väri, viimeistely mehiläisvahalla ja kasviöljyillä. Vaatteet GOTS-sertifioitua puuvillaa, pellavaa ja villaa.",
    "manufacturingCountry": "Puola",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-beech-doll-with-dress": {
    "recommendedAge": "2 v +",
    "ageMinMonths": 24,
    "dimensions": "Nukke 19 cm · Pakkauksen kanssa 14 × 22,5 × 5,5 cm",
    "weight": "200 g",
    "material": "FSC-sertifioitujen toimittajien pyökkipuu, luonnollinen puun väri, viimeistely mehiläisvahalla ja kasviöljyillä. Vaatteet GOTS-sertifioitua puuvillaa, pellavaa ja villaa.",
    "manufacturingCountry": "Puola",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-walnut-doll-with-dress": {
    "recommendedAge": "2 v +",
    "ageMinMonths": 24,
    "dimensions": "Nukke 19 cm · Pakkauksen kanssa 14 × 22,5 × 5,5 cm",
    "weight": "200 g",
    "material": "FSC-sertifioitujen toimittajien pähkinäpuu, luonnollinen puun väri, viimeistely mehiläisvahalla ja kasviöljyillä. Vaatteet GOTS-sertifioitua puuvillaa, pellavaa ja villaa.",
    "manufacturingCountry": "Puola",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "twist-bounce-wooden-ping-pong-paddles": {
    "ecology": "Valmistettu FSC-sertifioidusta puusta luonnonmateriaaleilla viimeisteltynä.",
    "featureList": [
      "Kehittää käsi-silmä-koordinaatiota ja tarkkuutta",
      "Kannustaa aktiiviseen leikkiin",
      "Puinen, kestävä rakenne"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-toy-acrobat-boy": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "Tanko 17,4 × 6,9 × 11,9 cm · Akrobaatti 14,3 × 13,5 × 0,8 cm · Pakkauksen kanssa 20,3 × 6,8 × 9,1 cm",
    "weight": "0,4 kg (pakkauksen kanssa)",
    "material": "FSC-sertifioitujen toimittajien puu, luonnolliset ekologiset pigmentit, viimeistely mehiläisvahalla ja kasviöljyillä. Ei haitallisia aineita.",
    "manufacturingCountry": "Puola",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-swing-and-catch-game": {
    "ecology": "FSC-sertifioitu puu, luonnonmateriaaleilla viimeistelty.",
    "featureList": [
      "Kehittää käsi-silmä-koordinaatiota",
      "Tukee tarkkuutta ja kärsivällisyyttä",
      "Puinen, ajaton muotoilu"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "montessori-egg-ball-and-square-set": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "Pienin osa Ø 4,3 cm · Suurin osa 6,6 × 6,6 cm",
    "weight": "0,2 kg",
    "material": "FSC-sertifioitujen toimittajien puu, viimeistely mehiläisvahalla ja kasviöljyillä. Ei haitallisia aineita.",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-tic-tac-toe-game": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "Pussi 7 × 12,5 cm · Palikat 3 × 3 × 0,8 cm",
    "weight": "41 g",
    "material": "FSC-sertifioitujen toimittajien puu, luonnollinen puun väri, viimeistely mehiläisvahalla ja kasviöljyillä.",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "dreamland-spinner-puzzle-natural": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "Palikka 4 × 4 × 4 cm · Ilman pakkausta 20,3 × 7,4 × 17 cm · Pakkauksen kanssa 22,5 × 8,3 × 19,7 cm",
    "weight": "0,8 kg",
    "material": "FSC-sertifioitujen toimittajien puu, viimeistely mehiläisvahalla ja kasviöljyillä. Ei haitallisia aineita.",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-petanque-game": {
    "ecology": "FSC-sertifioitu puu, luonnonmateriaaleilla viimeistelty.",
    "featureList": [
      "Kehittää tarkkuutta ja käsi-silmä-koordinaatiota",
      "Sopii sisä- ja ulkokäyttöön",
      "Puinen, kestävä rakenne"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "montessori-wooden-tray-accessories": {
    "ecology": "FSC-sertifioitu puu, luonnonmateriaaleilla viimeistelty.",
    "featureList": [
      "Sopii monenlaisiin Montessori-harjoituksiin",
      "Kehittää hienomotoriikkaa",
      "Puinen, luonnollinen rakenne"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-train": {
    "ecology": "FSC-sertifioitu puu, luonnonmateriaaleilla viimeistelty.",
    "featureList": [
      "Kehittää mielikuvitusta ja hienomotoriikkaa",
      "Puinen, kestävä rakenne",
      "Sopii ajattomaan leikkiin"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-toy-on-wheels-duck": {
    "ecology": "FSC-sertifioitu puu, luonnonmateriaaleilla viimeistelty.",
    "featureList": [
      "Kannustaa liikkumaan ja kävelemään",
      "Kehittää karkeamotoriikkaa",
      "Puinen, kestävä rakenne"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-teether": {
    "ecology": "FSC-sertifioitu puu, mehiläisvahalla ja kasvisöljyillä viimeistelty.",
    "featureList": [
      "Vauvan ensimmäinen puinen lelu",
      "Luonnonmateriaaleilla viimeistelty",
      "Pehmeä pinta suussa tutkittavaksi"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-rattle": {
    "recommendedAge": "0 v +",
    "ageMinMonths": 0,
    "ecology": "FSC-sertifioitua puuta\nLuonnolliset puun sävyt ja pinnat\nViimeistelty mehiläisvahalla ja kasviöljyillä\nEi haitallisia aineita, kyllästämätön\nEkologinen pakkaus: kierrätettävät pahvilaatikot tai pehmeät flanellipussit\nValmistettu Beskidin vuoristossa Puolassa",
    "featureList": [
      "Tukee hienomotoriikkaa ja silmän – käden yhteistyötä",
      "Ruokkii mielikuvitusta ja aistituntemuksia",
      "Sopii ikenien hieromiseen",
      "Tuottaa hellän, miellyttävän äänen",
      "Ergonominen muotoilu pieniin käsiin"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-shape-sorting-blocks": {
    "recommendedAge": "1 v +",
    "ageMinMonths": 12,
    "dimensions": "Suurin palikka 4,6 × 4,6 × 9,2 cm · Pienin palikka 4,3 × 3,9 × 3 cm · Setti 18,3 × 18,3 × 9,5 cm · Paino 1 kg",
    "ecology": "FSC-sertifioitua puuta\nViimeistelty mehiläisvahalla ja kasviöljyillä tai luonnollisilla pigmenteillä\nKierrätettävä pahvipakkaus\nEi haitallisia aineita\nValmistettu Beskidin vuoristossa Puolassa",
    "featureList": [
      "Setti sisältää 9 puuosaa",
      "Kehittää käden taitoja, keskittymistä ja loogista ajattelua",
      "Auttaa oppimaan muotoja ja värejä",
      "Kompakti, helppo kuljettaa"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-fence-puzzle": {
    "recommendedAge": "1 v +",
    "ageMinMonths": 12,
    "dimensions": "Suurin palikka 5 × 3,5 × 3,8 cm · Pienin 3 × 3 × 2,7 cm · Setti n. 30,7 × 7,3 × 17,3–18 cm · Paino 1 kg",
    "ecology": "FSC-sertifioitua laadukasta puuta\nLuonnolliset puun sävyt\nVaihtoehtoisesti luonnollisilla ekologisilla pigmenteillä\nViimeistelty mehiläisvahalla ja kasviöljyillä\nKierrätettävä pahvipakkaus\nEi haitallisia aineita",
    "featureList": [
      "Sileät, miellyttävät palat",
      "Opettaa hahmottamaan kokoja ja tilaa",
      "Kehittää silmän ja käden yhteistyötä",
      "Harjoittaa loogista ajattelua ja ongelmanratkaisua"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-story-tangram-in-storage-bag": {
    "featureList": [
      "Seitsemän perinteistä tangram-muotoa, jotka muodostavat neliön",
      "Kehittää mielikuvitusta, keskittymistä ja ongelmanratkaisua",
      "FSC-sertifioitu puu, viimeistelty luonnonöljyillä",
      "Sisältää kiristävän säilytyspussin ja kierrätettävän pahvipakkauksen",
      "Käsityönä Beskidin vuoristossa Puolassa",
      "Ikäsuositus 3 v +",
      "Kevyt ja helppo kuljettaa"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-puzzle-blocks": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "ecology": "Käsityönä FSC-sertifioidusta puusta\nViimeistelty mehiläisvahan ja kasviöljyjen sekoituksella\nEkologinen, kierrätettävä pahvipakkaus\nEi haitallisia aineita",
    "featureList": [
      "Opettaa vertaamaan esineiden mittasuhteita",
      "Kehittää hienomotoriikkaa ja näppäryyttä",
      "Vahvistaa keskittymistä ja tarkkuutta",
      "Tukee loogista ajattelua ja ongelmanratkaisua"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "wooden-blocks-in-a-box": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "ecology": "FSC-sertifioitua laadukasta puuta\nVärjätty luonnollisilla, ekologisilla pigmenteillä\nViimeistelty mehiläisvahalla ja kasviöljyillä\nKierrätettävä pahvipakkaus\nEi haitallisia aineita\nValmistettu Beskidin vuoristossa Puolassa",
    "featureList": [
      "Tarkasti käsityönä valmistetut palikat sileällä pinnalla",
      "Massiivipuinen säilytyslaatikko mukana",
      "Tukee mielikuvituksen ja tilanhahmotuksen kehitystä",
      "Kehittää aisteja ja hienomotoriikkaa"
    ],
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "pounding-bench": {
    "recommendedAge": "1 v +",
    "ageMinMonths": 12,
    "dimensions": "Tappi 2,3 × 2,3 × 7,5 cm · Ilman pakkausta 23,8 × 9 × 14,3 cm · Pakkauksen kanssa 25,8 × 9,3 × 16 cm",
    "weight": "0,85 kg",
    "material": "FSC-sertifioitujen toimittajien puu, suojattu luonnollisella mehiläisvahalla ja kasviöljyillä. Ei haitallisia aineita.",
    "includes": "Vasarointipenkki, puinen vasara ja 8 puutappia",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "secret-garden-wooden-spinning-puzzle": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "Ilman pakkausta 15 × 3 cm · Pakkauksen kanssa 15,5 × 12,5 × 3,3 cm",
    "weight": "45 g",
    "material": "FSC-sertifioitujen toimittajien puu, luonnolliset ekologiset pigmentit, viimeistely mehiläisvahalla ja kasviöljyillä. Ei haitallisia aineita.",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  },
  "lala-stick-figure-puzzle-lala-tikku-ukkopalapeli": {
    "recommendedAge": "3 v +",
    "ageMinMonths": 36,
    "dimensions": "6 × 6 × 16,5 cm (pakkauksen kanssa)",
    "weight": "0,20 kg",
    "material": "FSC-sertifioitujen toimittajien puu, luonnolliset ekologiset pigmentit, viimeistely mehiläisvahalla ja kasviöljyillä. Ei haitallisia aineita.",
    "standards": [
      "FSC-sertifioitu puu"
    ],
    "manufacturer": "Wooden Story"
  }
};
